import useGlobalModal from 'components/common/GlobalModal/useGlobalModal';
import VideoUploadModal from 'components/common/VideoUploadModal';
import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { UseControllerProps, useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import ReactPlayer from 'react-player';

export type VideoUploadControlProps = UseControllerProps<any> & {
  maxFileSize: number; // MB
};

function VideoUploadControl(props: VideoUploadControlProps) {
  const { t } = useTranslation();
  const { showGlobalModal } = useGlobalModal();
  const { maxFileSize } = props;
  const { field } = useController(props);

  //state
  const [isPlay, setIsPlay] = useState<boolean>(false);

  function handleUploadVideo({ path, maxFileSize }: { path: string; maxFileSize?: number }) {
    setIsPlay(false);
    showGlobalModal(() => (
      <VideoUploadModal
        maxFileSize={maxFileSize ?? 0}
        videopath={path}
        onReflect={(filename: string) => {
          field.onChange(filename);
        }}
      />
    ));
  }

  const isVideo = field.value && typeof field.value === 'string' && field.value.includes('mp4');
  const isImage =
    field.value &&
    typeof field.value === 'string' &&
    (field.value.includes('jpg') || field.value.includes('png') || field.value.includes('jpeg'));

  return (
    <div className="d-flex gap-3 justify-content-between">
      <div className="position-relative d-inline-block">
        {field.value && field.value.length > 0 ? (
          isVideo ? (
            <ReactPlayer
              playing={isPlay}
              url={process.env.REACT_APP_IMAGE_URL + field.value}
              controls
              width="100%"
              height="auto"
              onPlay={() => setIsPlay(true)}
              onPause={() => setIsPlay(false)}
            />
          ) : isImage ? (
            <img src={process.env.REACT_APP_IMAGE_URL + field.value} alt="" style={{ width: '100%', height: 'auto' }} />
          ) : (
            <div></div>
          )
        ) : null}
      </div>
      <div className="d-flex align-items-end">
        <Button
          className="d-inline-block"
          onClick={handleUploadVideo.bind(null, {
            path: field.value && field.value.length > 0 ? process.env.REACT_APP_IMAGE_URL + field.value : '',
            maxFileSize: maxFileSize,
          })}
        >
          {t('App.change')}
        </Button>
      </div>
    </div>
  );
}

export default VideoUploadControl;
